import React, { useMemo, useState, useContext } from 'react'
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { KPI } from 'src/mtska-frontend-app-component';
import KPISet from '../../Dashboard/views/components/RentalDashboard/KPISet';

const RentalManagerCarKPI = ({ filters, setFilters, userCapabilities }) => {
    const { t } = useTranslation();

    return useMemo(() => <>
        <Box className="mtska-chart-wrapper">
            <KPISet filters={filters} />
        </Box>
    </>, [filters])

}

export default RentalManagerCarKPI;


